import { keepPreviousData, useQuery } from '@tanstack/react-query';
import api from './axiosInterceptor';

const baseUrl = process.env.REACT_APP_NETLIFY_API_URL || process.env.REACT_APP_API_URL;

export default function FetchData(url, options = {}) {
    const fetcher = async () => {
        const response = await api.get(`${baseUrl}/${url}`)
        return response.data;
    };

    const { data, error, isLoading, isFetching, refetch } = useQuery({
        queryKey: [url],
        queryFn: fetcher,
        enabled: options.enabled ?? true,
        refetchInterval: options.refetchInterval,
        refetchIntervalInBackground: options.refetchIntervalInBackground ?? false,
        // Keep the prior page visible while the next page/filter request loads so
        // server-paginated DataGrids don't briefly see rowCount=0 and clamp to page 1.
        placeholderData:
            options.placeholderData !== undefined
                ? options.placeholderData
                : options.keepPrevious !== false
                  ? keepPreviousData
                  : undefined,
    });

    return {
        data,
        error,
        isLoading,
        isFetching,
        load: isLoading || isFetching,
        refetch,
    };
}